export const columns = [
  {
    title: 'Status',
    field: 'taskStatus'
  },
  {
    title: 'Creat de',
    field: 'createdBy'
  },
  {
    title: 'Data crearii',
    field: 'created',
    render: rowData => {
      const date = new Date(rowData.created);
      const formattedDate = `${date.toLocaleDateString('ro-RO')} / ${date.toLocaleTimeString('ro-RO', {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
      return formattedDate;
    }
  },
  {
    title: 'Actualizat de',
    field: 'updatedBy'
  },
  {
    title: 'Ultima actualizare',
    field: 'updated',
    render: rowData => {
      const date = new Date(rowData.updated);
      const formattedDate = `${date.toLocaleDateString('ro-RO')} / ${date.toLocaleTimeString('ro-RO', {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
      return formattedDate;
    }
  }
]
